import React, { useState, useRef, useCallback } from "react";
import { BrowserRouter, Routes, Route, Link, Switch } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import DayList from "./components/DayList";
import Add from "./components/Add";
import Month from "./components/Month";
import Item from "./components/Item";
import Bar from "./components/Bar";
import Main from "./components/Main"
import Profile from "./components/Profile"
const GlobalStyle = createGlobalStyle`
  body {
    background: #e9ecef;
  }
`;

function App() {
  const [daySelected, setDaySelected] = useState(new Date());
  var year=daySelected.getFullYear();
  var month=  ('0' + (daySelected.getMonth() + 1)).slice(-2);
  var day = ('0' + daySelected.getDate()).slice(-2);
  var dateString = year + '년 ' + month  + '월 ' + day+'일 ';

  return (
    <div className="wrapper">
      
      <Routes>
        <Route path="/Month" element={<Month></Month>} />
        <Route path="/" element={<Main></Main>} />
        <Route
          path="/DayList"
          element={<DayList date={dateString}></DayList>}
        />
  
        <Route path="/Item" element={<Item title="밥약 이름"></Item>} />
        <Route path="/Add" element={<Add date={dateString}></Add>} />
        <Route path="/Profile" element={<Profile></Profile>} />

      </Routes>
      
    </div>
  );
}

export default App;
